export default function CRegister() {
  return <h2>C Register</h2>;
}
